const transformCatalogCategoriesResponse = (data)=>data.map((item)=>transformCatalogCategoryResponse(item));
const transformCatalogCategoryResponse = ({ id , parent_id , position , level , category_seo_name , path , name , description , meta_title , meta_keywords , meta_description , meta_robots , image , mobile_image , childs , refilo_template , hide_filters , hide_sortby , tile_variant , heading_variant , is_anchor , all_children , refilo_view_mode_enabled , refilo_view_mode , refilo_siblings_categories_enabled , refilo_children_categories_enabled , refilo_ancestors_categories_enabled , emotional_products  } = {})=>({
        id: parseInt(id),
        parentId: parseInt(parent_id),
        name,
        description,
        image,
        imageMobile: mobile_image ?? null,
        path,
        position: parseInt(position),
        level: parseInt(level),
        seoMeta: {
            title: meta_title || '',
            description: meta_description || '',
            keywords: meta_keywords || '',
            robots: meta_robots || 'index,follow'
        },
        ogData: {
            title: meta_title || name,
            description: meta_description || description || '',
            image: image || '',
            url: ''
        },
        seoName: category_seo_name || null,
        childrenIds: childs || [],
        layout: {
            template: refilo_template || null
        },
        hideFilters: hide_filters || false,
        hideSortby: hide_sortby || false,
        tileVariant: tile_variant || '',
        headingVariant: heading_variant || '',
        isAnchor: !!is_anchor || false,
        allChildrenIds: all_children || [],
        viewModeEnabled: refilo_view_mode_enabled ?? true,
        viewModeDefault: refilo_view_mode ?? 'default',
        siblingsCategoriesEnabled: refilo_siblings_categories_enabled ?? true,
        childrenCategoriesEnabled: refilo_children_categories_enabled ?? true,
        ancestorsCategoriesEnabled: refilo_ancestors_categories_enabled ?? false,
        emotionalProducts: emotional_products?.map(({ display_page , display_position , columns_spacing , row_spacing  })=>({
                displayPage: display_page,
                displayPosition: display_position,
                columnsSpacing: columns_spacing || 1,
                rowsSpacing: row_spacing || 1
            })) || []
    });

export { transformCatalogCategoriesResponse, transformCatalogCategoryResponse };
